import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-examenes',
    templateUrl: './examenes.component.html',
    styleUrls: ['./examenes.component.css'],
    standalone: false
})
export class ExamenesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
